import { useSelector, useDispatch } from 'umi';
import { TIPS_VIEW_MODEL_NAMESPACE } from '@gp/models/tipsView';

import type { ITipsViewState } from '@gp/models/tipsView';

export default function useTipsView(key: string) {
  const dispatch = useDispatch();

  const { loading: tipsViewLoading, data: tipsView } = useSelector<any, ITipsViewState>(
    (rootState) => rootState?.[TIPS_VIEW_MODEL_NAMESPACE] || {},
  );

  const isTipsView = tipsViewLoading || !!tipsView?.[key];

  const handleViewedTips = (e?: React.SyntheticEvent) => {
    e?.stopPropagation();
    if (!key) return;
    dispatch({
      type: `${TIPS_VIEW_MODEL_NAMESPACE}/updateTipsViewStateTrue`,
      payload: [key],
    });
  };

  return { isTipsView, handleViewedTips };
}
